<div class="page-container">
    <div class="page-header">
        <div class="header-left">
            <span class="settings-desc">Control which email notifications are sent to each role.</span>
        </div>
        <div class="header-right">
            @if (!loading && settings.length > 0) {
                <button class="btn btn-md btn-primary" [disabled]="saving" (click)="saveSettings()">
                    <hugeicons-icon [icon]="checkIcon" [size]="18" color="currentColor"></hugeicons-icon>
                    {{ saving ? 'Saving...' : 'Save Changes' }}
                </button>
            }
        </div>
    </div>
    <div class="content-wrapper" [appDynamicHeight]="24">
        <div class="table-container card">
            @if (loading) {
                <div class="settings-empty">Loading settings...</div>
            } @else if (settings.length === 0) {
                <div class="settings-empty">No notification settings found.</div>
            } @else {
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Notification Type</th>
                            <th class="col-check">Admin</th>
                            <th class="col-check">Patient</th>
                            <th class="col-check">Attorney</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (setting of settings; track setting.id) {
                            <tr>
                                <td>{{ setting.notification_type }}</td>
                                <td class="col-check">
                                    <label class="toggle-check">
                                        <input type="checkbox" [checked]="setting.admin" (change)="toggleSetting(setting, 'admin')">
                                        <span class="toggle-slider"></span>
                                    </label>
                                </td>
                                <td class="col-check">
                                    <label class="toggle-check">
                                        <input type="checkbox" [checked]="setting.patient" (change)="toggleSetting(setting, 'patient')">
                                        <span class="toggle-slider"></span>
                                    </label>
                                </td>
                                <td class="col-check">
                                    <label class="toggle-check">
                                        <input type="checkbox" [checked]="setting.attorney" (change)="toggleSetting(setting, 'attorney')">
                                        <span class="toggle-slider"></span>
                                    </label>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
</div>
